import React from 'react';

import StepDiscovery from './howWeDoPartials/StepDiscovery';
import StepProject from './howWeDoPartials/StepProject';
import StepDevelopment from './howWeDoPartials/StepDevelopment';
import StepSupport from './howWeDoPartials/StepSupport';

export default function ServicesSteps() {
  return (
    <div className="vertical-steps big-padding">
      <StepDiscovery />
      <StepProject />
      <StepDevelopment />
      <StepSupport />
    </div>
  );
}
